// Live's "Upload as" (spec upload-into-project): "Upload to project", the brand's project picker
// with "Upload" (the picker of design-ref/folders-410/06, in live's words), whose Upload opens the
// file chooser in that click. The chosen files land in the folder picked, or at the top level for
// "All assets & files".
import { Button, Modal } from "@mantine/core";
import { useRef, useState } from "react";

import { MediaMime } from "../../api/generated/zod";
import { FolderPicker } from "../../platform/folders/FolderPicker";

interface UploadAsProps {
  teamId: string;
  brandId: string;
  onFiles: (files: File[], folderId: string | null) => void;
}

export function UploadAs({ teamId, brandId, onFiles }: UploadAsProps) {
  const [open, setOpen] = useState(false);
  const chooser = useRef<HTMLInputElement>(null);
  // The folder picked, kept for the chooser's answer.
  const folder = useRef<string | null>(null);
  return (
    <>
      <Button variant="filled-light" onClick={() => setOpen(true)}>
        Upload as
      </Button>
      {/* Its name doesn't contain the library chooser's: Playwright's getByLabel matches a part. */}
      <input
        ref={chooser}
        type="file"
        multiple
        hidden
        accept={MediaMime.options.join(",")}
        aria-label="Choose files for the project"
        onChange={(event) => {
          const files = Array.from(event.currentTarget.files ?? []);
          // Cleared, so the same file can be chosen again ("_1" naming).
          event.currentTarget.value = "";
          if (files.length > 0) onFiles(files, folder.current);
        }}
      />
      <Modal opened={open} onClose={() => setOpen(false)} title="Upload to project" centered size={400}>
        <FolderPicker
          teamId={teamId}
          brandId={brandId}
          submitLabel="Upload"
          onSubmit={(folderId) => {
            folder.current = folderId;
            setOpen(false);
            // In the click that chose the folder, which a browser asks of a file chooser.
            chooser.current?.click();
          }}
          onCancel={() => setOpen(false)}
        />
      </Modal>
    </>
  );
}
